module.exports = __webpack_public_path__ + "img/65.61ebb75a.png";